import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  Building,
  Category,
  Subcategory,
  ScheduleCategory,
  ScheduleDay,
  PeriodBulk,
  PeriodNormal,
  PeriodBreak,
  PeriodRegistration,
  PeriodCopy,
  ScheduleCategoryLink,
  TeacherAllocations,
  TrackerSwappingFilter,
  ScheduleGenerate,
  ScheduleGenerateFilter,
  EditSchoolPeriod,
  SubmissionAnalyticsClasses,
  SubmissionAnalyticsClassSections,
  TimetableSubmissionAnalytics
} from 'src/app/_models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudyTableService {
  url = environment.apiUrl;

  constructor(private http: HttpClient) {}

  GetDefinitionSetting() {
    return this.http.get(`${this.url}StudyTable/GetDefinitionSetting`);
  }

  CreateOrUpdateDefinitionSetting(type: number) {
    return this.http.post(`${this.url}StudyTable/CreateOrUpdateDefinitionSetting`, { type: type });
  }
  GetAllBuilding() {
    return this.http.get(`${this.url}StudyTable/GetAllBuilding`);
  }
  CreateBuildings(building: Building) {
    return this.http.post(`${this.url}StudyTable/CreateBuilding`, building);
  }
  DeleteBuilding(buildingId: number) {
    return this.http.delete(`${this.url}StudyTable/DeleteBuilding/${buildingId}`);
  }
  GetAllBuildingCategories(buildingId: number) {
    return this.http.get(`${this.url}StudyTable/GetAllBuildingCategories/${buildingId}`);
  }
  CreateCategories(category: Category) {
    return this.http.post(`${this.url}StudyTable/CreateBuildingCategories`, category);
  }
  DeleteBuildingCategory(buildingCategoryId: number) {
    return this.http.delete(`${this.url}StudyTable/DeleteBuildingCategory/${buildingCategoryId}`);
  }
  CreateBuildingSubCategories(subcategory: Subcategory) {
    return this.http.post(`${this.url}StudyTable/CreateBuildingSubCategories`, subcategory);
  }
  GetAllBuildingSubCategories(buildingCategoyId: number, pageIndex: number, pageSize: number) {
    return this.http.get(`${this.url}StudyTable/GetAllBuildingSubCategories/${buildingCategoyId}/${pageIndex}/${pageSize}`);
  }
  DeleteBuildingSubCategories(subcategoryId: number) {
    return this.http.delete(`${this.url}StudyTable/DeleteBuildingSubCategories/${subcategoryId}`);
  }
  UpdateBuildingSubCategories(BuildingSubCategoryModel: Subcategory) {
    return this.http.put(`${this.url}StudyTable/UpdateBuildingSubCategories`, BuildingSubCategoryModel);
  }
  UpdateBuildingCategories(UpdateBuildingCategoriesModel: Category) {
    return this.http.put(`${this.url}StudyTable/UpdateBuildingCategories`, UpdateBuildingCategoriesModel);
  }
  UpdateBuilding(UpdateBuildingModel: Building) {
    return this.http.put(`${this.url}StudyTable/UpdateBuilding`, UpdateBuildingModel);
  }
  // Start Schedule Category
  GetAllScheduleCategory() {
    return this.http.get(`${this.url}StudyTable/GetAllScheduleCategory`);
  }
  GetScheduleCategoryById(scheduleCategoryId: number) {
    return this.http.get(`${this.url}StudyTable/GetScheduleCategory/${scheduleCategoryId}`);
  }
  GetPeriodTypes() {
    return this.http.get(`${this.url}Lookups/GetPerodType`);
  }
  GetAllWeekDay() {
    return this.http.get(`${this.url}StudyTable/GetAllWeekDay`);
  }
  CreateSchaduleCategory(scheduleCategory: ScheduleCategory) {
    return this.http.post(`${this.url}StudyTable/CreateScheduleCategory`, scheduleCategory);
  }
  CreateScheduleDay(scheduleDay: ScheduleDay) {
    return this.http.post(`${this.url}StudyTable/CreateScheduleDay`, scheduleDay);
  }
  CreateScheduleDayCopy(periodCopy: PeriodCopy) {
    return this.http.post(`${this.url}StudyTable/CreateScheduleDayCopy`, periodCopy);
  }
  CreateSchedulePeriodBulk(periodBulk: PeriodBulk) {
    return this.http.post(`${this.url}StudyTable/CreateSchedulePeriodBulk`, periodBulk);
  }
  CreateSchedulePeriodNormal(periodNormal: PeriodNormal) {
    return this.http.post(`${this.url}StudyTable/CreateSchedulePeriod`, periodNormal);
  }
  CreateSchedulePeriodBreakAfterPeriod(periodBreak: PeriodBreak) {
    return this.http.post(`${this.url}StudyTable/CreateSchedulePeriodBreakAfterPeriod`, periodBreak);
  }
  CreateSchedulePeriodBreak(periodBreak: PeriodBreak) {
    return this.http.post(`${this.url}StudyTable/CreateSchedulePeriodBreak`, periodBreak);
  }
  CreateSchedulePeriodRegistration(periodRegistration: PeriodRegistration) {
    return this.http.post(`${this.url}StudyTable/CreateSchedulePeriodRegistration`, periodRegistration);
  }
  UpdateSchaduleCategory(scheduleCategory: ScheduleCategory) {
    return this.http.put(`${this.url}StudyTable/UpdateScheduleCategory`, scheduleCategory);
  }
  UpdateScheduleDay(scheduleDay: ScheduleDay) {
    return this.http.put(`${this.url}StudyTable/UpdateScheduleDay`, scheduleDay);
  }
  UpdateSchedulePeriod(periodNormal: PeriodNormal) {
    return this.http.put(`${this.url}StudyTable/UpdateSchedulePeriod`, periodNormal);
  }
  UpdateSchedulePeriodBreak(periodBreak: PeriodBreak) {
    return this.http.put(`${this.url}StudyTable/UpdateSchedulePeriodBreak`, periodBreak);
  }
  UpdateSchedulePeriodRegistration(periodRegistration: PeriodRegistration) {
    return this.http.put(`${this.url}StudyTable/UpdateSchedulePeriodRegistration`, periodRegistration);
  }
  DeleteScheduleCategory(scheduleCategoryId: number) {
    return this.http.delete(`${this.url}StudyTable/DeleteScheduleCategory/${scheduleCategoryId}`);
  }
  DeleteScheduleDay(scheduleDayId: number) {
    return this.http.delete(`${this.url}StudyTable/DeleteScheduleDay/${scheduleDayId}`);
  }
  DeleteSchedulePeriod(schedulePeriodId: number) {
    return this.http.delete(`${this.url}StudyTable/DeleteSchedulePeriod/${schedulePeriodId}`);
  }
  // End Schedule Category
  // Start Schedule Category Submission Analytics
  GetSubmissionAnalyticsClass(from: string, to: string): Observable<SubmissionAnalyticsClasses> {
    return this.http.get<SubmissionAnalyticsClasses>(`${this.url}StudyTable/GetSubmissionAnalyticsClass/${from}/${to}`);
  }
  GetSubmissionAnalyticsSection(classId: number, from: string, to: string): Observable<SubmissionAnalyticsClassSections[]> {
    return this.http.get<SubmissionAnalyticsClassSections[]>(
      `${this.url}StudyTable/GetSubmissionAnalyticsSection/${classId}/${from}/${to}`
    );
  }
  GetSubmissionAnalytics(classId: number, sectionId: number, from: string, to: string): Observable<TimetableSubmissionAnalytics[]> {
    return this.http.get<TimetableSubmissionAnalytics[]>(
      `${this.url}StudyTable/GetSubmissionAnalytics/${classId}/${sectionId}/${from}/${to}`
    );
  }
  // End Schedule Category Submission Analytics
  // Start Schedule Category Link
  GetAllScheduleCategoryLinks() {
    return this.http.get(`${this.url}StudyTable/GetAllLinkScheduleCategory`);
  }
  GetScheduleCategoryLinkById(linkScheduleCategoryId: number) {
    return this.http.get(`${this.url}StudyTable/GetLinkScheduleCategoryById/${linkScheduleCategoryId}`);
  }
  CreateScheduleCategoryLink(scheduleCategoryLink: ScheduleCategoryLink) {
    return this.http.post(`${this.url}StudyTable/CreateLinkScheduleCategory`, scheduleCategoryLink);
  }
  UpdateScheduleCategoryLink(scheduleCategoryLink: ScheduleCategoryLink) {
    return this.http.put(`${this.url}StudyTable/UpdateLinkScheduleCategory`, scheduleCategoryLink);
  }
  DeleteScheduleCategoryLink(linkScheduleCategoryId: number) {
    return this.http.delete(`${this.url}StudyTable/DeleteLinkScheduleCategory/${linkScheduleCategoryId}`);
  }
  // End Schedule Category Link
  // Start Assign Teachers
  GetTeacherAllocationInfo(teacherId: string) {
    return this.http.get(`${this.url}StudyTable/GetTeacherAllocationInfo/${teacherId}`);
  }
  CreateOrUpdateTeacherAllocation(teacherAllocations: TeacherAllocations[]) {
    return this.http.post(`${this.url}StudyTable/CreateOrUpdateTeacherAllocation`, teacherAllocations);
  }
  DeleteTeacherAllocation(teacherAllocationId: number) {
    return this.http.delete(`${this.url}StudyTable/DeleteTeacherAllocation/${teacherAllocationId}`);
  }
  // End Assign Teachers
  // Start Schedule Generate
  GetAllLinkScheduleCategoriesByClassAndSection(classId: number, sectionId: number) {
    return this.http.get(`${this.url}StudyTable/GetAllLinkScheduleCategory/${classId}/${sectionId}`);
  }

  AutoGenerateStudyTable(classId: number, sectionId: number, linkScheduleCategoryId: number) {
    return this.http.post(`${this.url}StudyTable/AutoGenerateStudyTable`, { classId, sectionId, linkScheduleCategoryId });
  }
  AutoGenerateStudyTableVerifcation(classId: number, sectionId: number, linkScheduleCategoryId: number) {
    return this.http.post(`${this.url}StudyTable/AutoGenerateStudyTableVerifcation`, { classId, sectionId, linkScheduleCategoryId });
  }
  GetAutoGenerateStudyTable() {
    return this.http.get(`${this.url}StudyTable/GetAutoGenerateStudyTable`);
  }
  DeleteCacheStudyTable() {
    return this.http.delete(`${this.url}StudyTable/DeleteCacheStudyTable`);
  }
  SaveCacheStudyTable() {
    return this.http.post(`${this.url}StudyTable/SaveCacheStudyTable`, null);
  }
  GetScheduleCategoryByLinkCatigory(linkScheduleCategoryId: number) {
    return this.http.get(`${this.url}StudyTable/GetScheduleCategoryByLinkCatigory/${linkScheduleCategoryId}`);
  }
  ManualGenerateStudyTable(scheduleGenerate: ScheduleGenerate) {
    return this.http.post(`${this.url}StudyTable/ManualGenerateStudyTable`, scheduleGenerate);
  }
  GetEditableStudyTable(scheduleGenerateFilter: ScheduleGenerateFilter): Observable<ScheduleDay[]> {
    return this.http.post<ScheduleDay[]>(`${this.url}StudyTable/GetEditableStudyTable`, scheduleGenerateFilter);
  }
  EditPriodsStudyTable(editSchoolPeriod: EditSchoolPeriod[]) {
    return this.http.put(`${this.url}StudyTable/EditPriodsStudyTable`, editSchoolPeriod);
  }
  // End Schedule Generate
  // Start View Schedule
  GetStudyTableByClassSectionId(classId: number, sectionId: number) {
    return this.http.get(`${this.url}StudyTable/GetStudyTable/${classId}/${sectionId}`);
  }
  GetStudyTableByDate(classId: number, sectionId: number, date: string) {
    return this.http.get(`${this.url}StudyTable/GetStudyTable/${classId}/${sectionId}/${date}`);
  }
  GetStudentByClassSectionId(classId: number, sectionId: number) {
    return this.http.get(`${this.url}StudyTable/GetStudentByClassSection/${classId}/${sectionId}`);
  }
  GetTeacherStudyTable(teacherId: string) {
    return this.http.get(`${this.url}StudyTable/GetTeacherStudyTable/${teacherId}`);
  }
  GetSubjectStudyTable(subjectId: number) {
    return this.http.get(`${this.url}StudyTable/GetSubjectStudyTable/${subjectId}`);
  }
  GetOccupancyStudyTable(categoryId: number, dayId: number) {
    return this.http.get(`${this.url}StudyTable/GetOccupancyStudyTable/${categoryId}/${dayId}`);
  }
  GetDayForCategory(categoryId: number) {
    return this.http.get(`${this.url}StudyTable/GetDayForCategory/${categoryId}`);
  }
  GetDaysByClass(classId: number) {
    return this.http.get(`${this.url}StudyTable/GetDayForCategoryByClass/${classId}`);
  }
  GetDaysByClassSection(classId: number, sectionId: number) {
    return this.http.get(`${this.url}StudyTable/GetDayForCategoryByClassSection/${classId}/${sectionId}`);
  }
  GetDaysBySubject(subjectId: number) {
    return this.http.get(`${this.url}StudyTable/GetDayForCategoryBySubjectId/${subjectId}`);
  }
  GetSubjectDayStudyTable(subjectDayId: number) {
    return this.http.get(`${this.url}StudyTable/GetSubjectDayStudyTable/${subjectDayId}`);
  }
  // End View Schedule
  // Start Tracker
  GetSwapedStudyTable(classId: number, sectionId: number, date: string) {
    return this.http.get(`${this.url}StudyTable/GetSwapedStudyTable/${classId}/${sectionId}/${date}`);
  }
  swapBySubject(trackerSwappingFilter: TrackerSwappingFilter) {
    return this.http.post(`${this.url}StudyTable/SubjectSwaped`, trackerSwappingFilter);
  }
  swapByTeacher(trackerSwappingFilter: TrackerSwappingFilter) {
    return this.http.post(`${this.url}StudyTable/TeacherSwaped`, trackerSwappingFilter);
  }
  CancelPeriodSwaped(trackerSwappingFilter: TrackerSwappingFilter) {
    return this.http.post(`${this.url}StudyTable/CancelPeriodSwaped`, trackerSwappingFilter);
  }
  RevertSwapped(swapedId: number) {
    return this.http.delete(`${this.url}StudyTable/RevertSwaped/${swapedId}`);
  }
  GetSwapedReportTable(fromDate: string, toDate: string) {
    return this.http.get(`${this.url}StudyTable/GetSwapedStudyTable/${fromDate}/${toDate}`);
  }

  GetScheduleSummary() {
    return this.http.get(`${this.url}StudyTable/GetScheduleSummary`);
  }
  // End Tracker
}
